function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { Statistic, Button, Skeleton, Descriptions, Divider, DatePicker, Form } from 'antd';
import { Table } from "react-bootstrap";
import { useOutletContext } from "react-router-dom";
import Common from "../components/includes/Common";
import { PrinterFill, HouseFill } from "react-bootstrap-icons";
import moment from 'moment';
import dayjs from 'dayjs';
var RangePicker = DatePicker.RangePicker;
import { PersonFill, Cash, WalletFill, CreditCardFill, PeopleFill } from 'react-bootstrap-icons';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var ReduceHome = function ReduceHome() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDataLoading = _useState2[0],
    setIsDataLoading = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isCustomerDataLoading = _useState4[0],
    setIsCustomerDataLoading = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    customers = _useState6[0],
    setCustomers = _useState6[1];
  var _useOutletContext = useOutletContext(),
    _useOutletContext2 = _slicedToArray(_useOutletContext, 2),
    newCustomerCreated = _useOutletContext2[0],
    setNewCustomerCreated = _useOutletContext2[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    stats = _useState8[0],
    setStats = _useState8[1];
  var _useState9 = useState(true),
    _useState0 = _slicedToArray(_useState9, 2),
    zonesDataLoading = _useState0[0],
    setZonesDataLoading = _useState0[1];
  var _useState1 = useState([]),
    _useState10 = _slicedToArray(_useState1, 2),
    zonesData = _useState10[0],
    setZonesData = _useState10[1];
  var today = new Date();
  var date = today.getDate() + '/' + (today.getMonth() + 1) + '/' + today.getFullYear();
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    selectedCustomer = _useState12[0],
    setSelectedCustomer = _useState12[1];
  var _useState13 = useState(moment().startOf('day').format()),
    _useState14 = _slicedToArray(_useState13, 2),
    from = _useState14[0],
    setFrom = _useState14[1];
  var _useState15 = useState(moment().endOf('day').format()),
    _useState16 = _slicedToArray(_useState15, 2),
    to = _useState16[0],
    setTo = _useState16[1];
  var disabledDate = function disabledDate(current) {
    return current && current < dayjs('2023-08-01');
  };
  useEffect(function () {
    setIsDataLoading(true);
    console.log('User id ' + Common.currentUser.id);
    axios.get(Common.baseApiUrl + 'getcurrentcustomersfr/' + from + "/" + to + "/" + Common.currentUser.id).then(function (response) {
      setIsDataLoading(false);
      if (response.data.status == 200) {
        setCustomers(response.data.customers);
      }
    })["catch"](function (error) {
      setIsDataLoading(false);
    });
  }, [newCustomerCreated, from, to]);
  var onSearchFinish = function onSearchFinish(values) {
    console.log(values.period);
    setFrom(moment(values.period[0].$d).format());
    setTo(moment(values.period[1].$d).format());
  };
  useEffect(function () {
    setZonesDataLoading(false);
    axios.get(Common.baseApiUrl + 'getzonescustomersfr/' + from + "/" + to + "/" + Common.currentUser.id).then(function (response) {
      setZonesDataLoading(false);
      if (response.data.status == 200) {
        //setZonesData(response.data.zones);
        var zdata = new Array();
        response.data.zones.forEach(function (z) {
          var zcu = 0;
          var zcashcu = 0;
          var ztpecu = 0;
          var zomcu = 0;
          var zsoccu = 0;
          z.users.forEach(function (u) {
            zcu += u.customers.length;
            zcashcu += u.customers.filter(function (customer) {
              return customer.paymentmethod.id == 1;
            }).length * 120000;
            zomcu += u.customers.filter(function (customer) {
              return customer.paymentmethod.id == 2;
            }).length * 120000;
            ztpecu += u.customers.filter(function (customer) {
              return customer.paymentmethod.id == 3;
            }).length * 120000;
            zsoccu += u.customers.filter(function (customer) {
              return customer.paymentmethod.id > 3;
            }).length * 120000;
          });
          zdata.push({
            id: z.id,
            code: z.code,
            label: z.label,
            cash: zcashcu,
            om: zomcu,
            tpe: ztpecu,
            soc: zsoccu,
            total: zcu
          });
        });
        setZonesData(zdata);
      }
    })["catch"](function (error) {
      setIsDataLoading(false);
    });
  }, [from, to]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsx(Form, {
        onFinish: onSearchFinish,
        layout: "vertical",
        children: /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: 5,
            md: 6,
            sm: 8,
            children: /*#__PURE__*/_jsx(Form.Item, {
              name: "period",
              rules: [{
                required: true,
                message: "Ce champ est obligatoire"
              }],
              children: /*#__PURE__*/_jsx(RangePicker, {
                disabledDate: disabledDate
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            children: /*#__PURE__*/_jsx(Form.Item, {
              children: /*#__PURE__*/_jsx(Button, {
                type: "primary",
                htmlType: "submit",
                children: /*#__PURE__*/_jsx("b", {
                  children: "CHERCHER"
                })
              })
            })
          })]
        })
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 5,
          md: 5,
          children: /*#__PURE__*/_jsxs("div", {
            className: "white-bg cool-radius",
            children: [/*#__PURE__*/_jsx("span", {
              children: "Du ".concat(moment(from).format("DD/MM/YYYY"), " Au ").concat(moment(to).format("DD/MM/YYYY"))
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), !isDataLoading ? /*#__PURE__*/_jsx(_Fragment, {
              children: /*#__PURE__*/_jsxs(Row, {
                children: [/*#__PURE__*/_jsxs(Col, {
                  lg: 6,
                  md: 6,
                  sm: 6,
                  children: [/*#__PURE__*/_jsx("h5", {
                    children: "JOURNEE"
                  }), /*#__PURE__*/_jsxs(Row, {
                    children: [/*#__PURE__*/_jsx(Col, {
                      lg: 12,
                      md: 12,
                      sm: 12,
                      children: /*#__PURE__*/_jsx(Statistic, {
                        title: "Total clients",
                        value: customers.filter(function (c) {
                          return c.user.zone.code != 'MAD' && c.user.zone.code != 'KAL';
                        }).length.toLocaleString('Fr'),
                        prefix: /*#__PURE__*/_jsx(PersonFill, {})
                      })
                    }), /*#__PURE__*/_jsx(Col, {
                      lg: 12,
                      md: 12,
                      sm: 12,
                      children: /*#__PURE__*/_jsx(Statistic, {
                        title: "Total Encaissement (GNF)",
                        value: (customers.filter(function (c) {
                          return c.user.zone.code != 'MAD' && c.user.zone.code != 'KAL';
                        }).length * 120000).toLocaleString('Fr'),
                        prefix: /*#__PURE__*/_jsx(Cash, {})
                      })
                    })]
                  })]
                }), /*#__PURE__*/_jsx(Col, {
                  lg: 6,
                  md: 6,
                  sm: 6,
                  children: /*#__PURE__*/_jsxs("div", {
                    className: "cool-radius",
                    style: {
                      background: '#FFDE08'
                    },
                    children: [/*#__PURE__*/_jsx(Statistic, {
                      title: "CASH (GNF)",
                      value: (customers.filter(function (customer) {
                        return customer.paymentmethod.id == 1 && customer.user.zone.code != 'MAD' && customer.user.zone.code != 'KAL';
                      }).length * 120000).toLocaleString('Fr'),
                      prefix: /*#__PURE__*/_jsx(Cash, {})
                    }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(Statistic, {
                      title: "OM (GNF)",
                      value: (customers.filter(function (customer) {
                        return customer.paymentmethod.id == 2 && customer.user.zone.code != 'MAD' && customer.user.zone.code != 'KAL';
                      }).length * 120000).toLocaleString('Fr'),
                      prefix: /*#__PURE__*/_jsx(WalletFill, {})
                    }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(Statistic, {
                      title: "TPE (GNF)",
                      value: (customers.filter(function (customer) {
                        return customer.paymentmethod.id == 3 && customer.user.zone.code != 'MAD' && customer.user.zone.code != 'KAL';
                      }).length * 120000).toLocaleString('Fr'),
                      prefix: /*#__PURE__*/_jsx(CreditCardFill, {})
                    }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(Statistic, {
                      title: "SOCIETE (GNF)",
                      value: (customers.filter(function (customer) {
                        return customer.paymentmethod.id > 3 && customer.user.zone.code != 'MAD' && customer.user.zone.code != 'KAL';
                      }).length * 120000).toLocaleString('Fr'),
                      prefix: /*#__PURE__*/_jsx(HouseFill, {})
                    })]
                  })
                })]
              })
            }) : /*#__PURE__*/_jsx(Skeleton, {
              active: true
            })]
          })
        }), (JSON.parse(localStorage.getItem('userData')).role == 10 || JSON.parse(localStorage.getItem('userData')).role == 11 || JSON.parse(localStorage.getItem('userData')).role == 8 || JSON.parse(localStorage.getItem('userData')).role == 9 || JSON.parse(localStorage.getItem('userData')).role == 7 || JSON.parse(localStorage.getItem('userData')).role == 21) && /*#__PURE__*/_jsx(Col, {
          lg: 7,
          md: 7,
          children: /*#__PURE__*/_jsxs("div", {
            className: "white-bg cool-radius",
            children: [/*#__PURE__*/_jsx("span", {
              children: "Du ".concat(moment(from).format("DD/MM/YYYY"), " Au ").concat(moment(to).format("DD/MM/YYYY"))
            }), /*#__PURE__*/_jsx("h5", {
              children: "ZONES OPERATIONNELLES"
            }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs(Table, {
              size: "sm",
              bordered: true,
              responsive: true,
              striped: true,
              children: [/*#__PURE__*/_jsx("thead", {
                children: /*#__PURE__*/_jsxs("tr", {
                  children: [/*#__PURE__*/_jsx("th", {
                    children: "Zone"
                  }), /*#__PURE__*/_jsx("th", {
                    children: /*#__PURE__*/_jsx(PeopleFill, {
                      size: 22
                    })
                  }), /*#__PURE__*/_jsx("th", {
                    children: "CASH"
                  }), /*#__PURE__*/_jsx("th", {
                    children: "OM"
                  }), /*#__PURE__*/_jsx("th", {
                    children: "TPE"
                  }), /*#__PURE__*/_jsx("th", {
                    children: "SOC"
                  }), /*#__PURE__*/_jsx("th", {
                    children: "TOTAL"
                  })]
                })
              }), /*#__PURE__*/_jsx("tbody", {
                children: zonesData.length > 0 && zonesData.filter(function (z) {
                  return z.code != 'MAD' && z.code != 'KAL';
                }).map(function (z) {
                  return /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: z.code
                    }), /*#__PURE__*/_jsx("td", {
                      children: z.total.toLocaleString('Fr')
                    }), /*#__PURE__*/_jsx("td", {
                      children: z.cash.toLocaleString('Fr')
                    }), /*#__PURE__*/_jsx("td", {
                      children: z.om.toLocaleString('Fr')
                    }), /*#__PURE__*/_jsx("td", {
                      children: z.tpe.toLocaleString('Fr')
                    }), /*#__PURE__*/_jsx("td", {
                      children: z.soc.toLocaleString('Fr')
                    }), /*#__PURE__*/_jsx("td", {
                      children: (z.total * 120000).toLocaleString('Fr')
                    })]
                  }, z.id);
                })
              })]
            })]
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 8,
          md: 9
        })]
      }), isDataLoading && /*#__PURE__*/_jsx(Skeleton, {
        active: true
      })]
    })
  });
};
export default ReduceHome;